import type { WellnessActivityType } from "@/models/wellness/WellnessActivityType";
import type { WellnessCalculationResult } from "@/models/wellness/WellnessCalculationResult";

export const preferredActivityTypeOrder = [
  "Walking",
  "Jogging",
  "Running",
  "Bicycling",
];

function normalizeText(value?: string | null) {
  return value?.trim().toLowerCase() || "";
}

export function getActivityTypeRank(typeName?: string | null, activityName?: string | null) {
  const normalizedTypeName = normalizeText(typeName);
  const normalizedActivityName = normalizeText(activityName);

  if (normalizedTypeName === "walking") return 0;
  if (normalizedTypeName === "jogging") return 1;
  if (normalizedTypeName === "running" && normalizedActivityName.includes("jogging")) {
    return 1;
  }
  if (normalizedTypeName === "running") return 2;
  if (normalizedTypeName === "bicycling") return 3;
  return preferredActivityTypeOrder.length;
}

export function getActivityTypeGroupLabel(
  typeName?: string | null,
  activityName?: string | null,
) {
  const rank = getActivityTypeRank(typeName, activityName);
  return preferredActivityTypeOrder[rank] || typeName || "Other";
}

export function sortActivityTypes(
  activityTypes: WellnessActivityType[],
) {
  return [...activityTypes].sort((a, b) => {
    const byRank = getActivityTypeRank(a.name) - getActivityTypeRank(b.name);
    if (byRank !== 0) {
      return byRank;
    }

    return a.displayOrder - b.displayOrder || a.name.localeCompare(b.name);
  });
}

export function sortCalculationResults(
  results: WellnessCalculationResult[],
) {
  return [...results].sort((a, b) => {
    const byRank =
      getActivityTypeRank(a.activityTypeName, a.activityName) -
      getActivityTypeRank(b.activityTypeName, b.activityName);
    if (byRank !== 0) {
      return byRank;
    }

    const byType = a.activityTypeName.localeCompare(b.activityTypeName);
    if (byType !== 0) {
      return byType;
    }

    return a.activityName.localeCompare(b.activityName);
  });
}
